// extracted by mini-css-extract-plugin
export default {"card":"ServiceScheduleList_card__u+bvV","cardActive":"ServiceScheduleList_cardActive__D+uzJ"};